import Vue, { KeepAlive } from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'

import Index from '../views/index/index.vue'



// 在重写push|replace方法时，先把VueRouter原型对象的push|replace保存一份
let originPush = VueRouter.prototype.push
let originReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function (location, resolve, reject) {
    if (resolve && reject) {
        originPush.call(this, location, resolve, reject)
    } else {
        originPush.call(this, location, () => { }, () => { })
    }
}
VueRouter.prototype.replace = function (location, resolve, reject) {
    if (resolve && reject) {
        originReplace.call(this, location, resolve, reject)
    } else {
        originReplace.call(this, location, () => { }, () => { })
    }
  }


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect:'/index/index',
    
    children:[
      {
        path:'index/index',
        name:'Index',
        component:Index
      },
      {
        path:'index/meterialDetail',
        name:'MaterialDetail',
        component:()=>import('../views/index/meterialDetail.vue'),
        meta:{
          noAlive:true
        }
      },
      {
        path:'index/message',
        name:'Message',
        component:()=>import('../views/message/index.vue'),
        meta:{
          noAlive:true
        }
      },
      {
        path:'index/message/messageDetail',
        name:'MessageDetail',
        component:()=>import('../views/message/messageDetail.vue'),
        meta:{
          noAlive:true
        }
      },
      {
        path:'index/valuationRecovery',
        name:'ValuationRecovery',
        component:()=>import('../views/valuationRecovery/index.vue')
      },
      {
        path:'index/myorder',
        name:'Myorder',
        component:()=>import('../views/myOrder/index.vue'),
        meta:{
          noAlive:true
        }
      },
      {
        path:'index/myorder/orderDetail',
        name:'OrderDetail',
        component:()=>import('../views/myOrder/orderDetail.vue'),
         meta:{
          noAlive:true
        }
      },
      {
        path:'index/commonProblem',
        name:'CommonProblem',
        component:()=>import('../views/commonProblem/index.vue')
      },
      {
        path:'index/myService',
        name:'MyService',
        component:()=>import('../views/myService/index.vue'),
         meta:{
          noAlive:true
        }
      },
      {
        path:'index/rules',
        name:'Rules',
        component:()=>import('../views/rules/index.vue'),
         meta:{
          noAlive:true
        }
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: ()=>import('../views/login/index.vue'),
  }
     
    //   {
    //     path:'home/user',
    //     name:'User',
    //     component:()=>import('../views/home/user.vue'),
    //     redirect:'/user/userInfo',
    //     children:[
    //         {
    //             path:'/user/userInfo',
    //             name:'UserInfo',
    //             component:()=>import('../views/home/user/userInfo.vue'),
    //         },
    //         {
    //             path:'/user/inviteFriends',
    //             name:'InviteFriends',
    //             component:()=>import('../views/home/user/inviteFriends.vue'),
    //         },
    //         {
    //             path:'/user/subscripRecord',
    //             name:'SubscripRecord',
    //             component:()=>import('../views/home/user/subscripRecord.vue'),
    //         },
    //         {
    //             path:'/user/myCommunity',
    //             name:'MyCommunity',
    //             component:()=>import('../views/home/user/myCommunity.vue'),
    //         },
            
    //         {
    //             path:'/user/walletRecord',
    //             name:'WalletRecord',
    //             component:()=>import('../views/home/user/walletRecord.vue'),
    //         },

            
    //     ]
    //   },
    // ],
   
  // },
  // {
  //   path:'/*',
  //   name:'notFound',
  //   component:()=>import('../views/home/notFound.vue'),
  // }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  routes
})

// router.beforeEach((to,from,next)=>{
//     let token=window.localStorage.getItem('token')
//     if(to.name=='UserInfo'){
//         if(!token){
//             next(()=>{
//                 router.push({name:'Login'})
//             })
//         }
//         console.log('woyaotiaole ')
        
//     }
//     next()
// })

export default router
